module.exports = __webpack_public_path__ + "img/boundary-selector-logo.a492e4fe.svg";